import { baseApi } from './baseApi';
import { normalizeKeys } from '../../utils/transform';

export interface OrgModelUsedBy {
  agent_id: string;
  name: string;
}

export interface OrgModel {
  productId: string;
  displayName: string;
  /** @deprecated Prefer `route`. Alias of route for one release. */
  provider: string;
  lab?: string;
  route?: string;
  family?: string;
  capabilities: string[];
  enabled: boolean;
  chatCapable?: boolean;
  usedAsDefaultBy?: OrgModelUsedBy[];
}

export interface OrgModelsResponse {
  models: OrgModel[];
}

export interface PatchOrgModelRequest {
  orgId: string;
  productId: string;
  enabled: boolean;
  confirmInUse?: boolean;
}

export const orgModelsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrgModels: builder.query<OrgModel[], string>({
      query: (orgId) => `/portal/organisations/${orgId}/models`,
      transformResponse: (response: unknown) => {
        const normalized = normalizeKeys<OrgModelsResponse>(response);
        return normalized.models ?? [];
      },
      providesTags: ['OrgModel'],
    }),

    patchOrgModel: builder.mutation<OrgModel, PatchOrgModelRequest>({
      query: ({ orgId, productId, enabled, confirmInUse }) => ({
        url: `/portal/organisations/${orgId}/models/${encodeURIComponent(productId)}`,
        method: 'PATCH',
        body: {
          enabled,
          ...(confirmInUse ? { confirm_in_use: true } : {}),
        },
      }),
      transformResponse: (response: unknown) => normalizeKeys<OrgModel>(response),
      invalidatesTags: ['OrgModel'],
    }),
  }),
});

export const { useGetOrgModelsQuery, usePatchOrgModelMutation } = orgModelsApi;
